import { gql } from '__generated__';

export default gql(`
  mutation DeleteMollieConnection($id: ID!) {
    deleteMollieConnection(id: $id) {
      id
      mollie_connections {
        ...MollieConnectionFields
      }
    }
  }
`);
